import { lazyRouteComponent } from "@tanstack/react-router";


export const TITLE = "Slutför köp – Alkoholprovet";

const CheckoutPage = lazyRouteComponent(() => import("./checkout.view"), "CheckoutPage");

const PLANS = [
  "premium_10d_once", "premium_30d_once_v2", "premium_90d_once",
  "premium_10d_winback", "premium_colleague_10d",
] as const;
export type CheckoutPlan = (typeof PLANS)[number];

export const routeOptions = {
  component: CheckoutPage,
  validateSearch: (
    s: Record<string, unknown>,
  ): { plan: CheckoutPlan; rabatt?: "1" } => ({
    plan:
      typeof s.plan === "string" && (PLANS as readonly string[]).includes(s.plan)
        ? (s.plan as CheckoutPlan)
        : ("premium_30d_once_v2" as const),
    // TanStack Router JSON-parsar query-värden: ?rabatt=1 blir talet 1.
    rabatt: s.rabatt === "1" || s.rabatt === 1 ? ("1" as const) : undefined,
  }),

  head: () => ({
    meta: [
      { title: TITLE },
      { name: "robots", content: "noindex" },
    ],
  }),
};
